const PATHS = {};

PATHS.LOGIN = "/login";
PATHS.HOME = "/home";
PATHS.SETTING_PROFILE = "/setting/profile";
PATHS.SETTING_SECURITY = "/setting/security";

export default PATHS;
